import { render, staticRenderFns } from "./ShowProduct.vue?vue&type=template&id=7c8c08ee&scoped=true&"
import script from "./ShowProduct.vue?vue&type=script&lang=js&"
export * from "./ShowProduct.vue?vue&type=script&lang=js&"
import style0 from "./ShowProduct.vue?vue&type=style&index=0&id=7c8c08ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8c08ee",
  null
  
)

component.options.__file = "ShowProduct.vue"
export default component.exports